import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './data/en.json';
import ukTranslations from './data/uk.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    uk: {
      translation: ukTranslations,
    },
  },
  fallbackLng: 'en',
});

export default i18n;
